// ======================================================================
// File: src/modules/ppe/pages/procurement/grn/form/GRNLineDrawer.jsx
// Module: PPE → Procurement → GRN
//
// Purpose:
// - Add GRN line with proper searchable dropdowns
// - PO Line → Material → UOM auto fill
// ======================================================================

import React, { useState, useEffect } from "react";
import grnService from "../services/grnService";
import "../grn-ui.css";

import SearchableDropdown from "../../../../components/common/SearchableDropdown";

import poLineLookupService from "../services/poLineLookupService";
import materialLookupService from "../services/materialLookupService";
import uomLookupService from "../services/uomLookupService";

export default function GRNLineDrawer({
  open,
  grnId,
  poId,
  record,
  onClose,
  onSaved,
}) {

  const [form, setForm] = useState({
    po_line_id: "",
    po_line_label: "",

    material_type: "RAW_MATERIAL",

    material_id: "",
    material_label: "",

    received_qty: "",
    uom: "",
    uom_label: "",

    unit_price: "",

    batch_no: "",
    expiry_date: "",

    pending_qty: 0,
  });

  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open) return;

    setForm({
      po_line_id: "",
      po_line_label: "",

      material_type: "RAW_MATERIAL",

      material_id: "",
      material_label: "",

      received_qty: "",
      uom: "",
      uom_label: "",

      unit_price: "",

      batch_no: "",
      expiry_date: "",

      pending_qty: 0,
    });
  }, [open]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleSave = async () => {
    try {
      setSaving(true);

      if (!form.batch_no?.trim()) {
        alert("Batch No is required");
        setSaving(false);
        return;
      }

      if (!form.expiry_date) {
        alert("Expiry Date is required");
        setSaving(false);
        return;
      }

      const payload = {
        po_line_id: form.po_line_id,
        material_type: form.material_type,
        material_id: form.material_id,
        received_qty: form.received_qty,
        uom: form.uom,
        unit_price: form.unit_price,
        batch_no: form.batch_no,
        expiry_date: form.expiry_date,
      };

      await grnService.addGRNLine(grnId, payload);

      alert("GRN line added successfully");

      if (onSaved) onSaved();

      onClose();

    } catch (error) {
      alert(
        error?.response?.data?.message ||
        "Failed to add GRN line"
      );
    } finally {
      setSaving(false);
    }
  };

  console.log("PO ID received in GRNLineDrawer:", poId);

  if (!open) return null;

  return (
    <div className="erp-drawer-overlay">
      <div className="erp-drawer">

        <div className="erp-drawer-header">
          <h5>Add GRN Line</h5>
          <button className="btn-close" onClick={onClose} />
        </div>

        <div className="erp-drawer-body">
          <div className="row g-3">

            {/* PO LINE DROPDOWN */}
            <div className="col-12">
              <SearchableDropdown
                label="PO Line"
                value={form.po_line_label}

                placeholder={
                  poId
                    ? "Search PO Line..."
                    : "Select PO first"
                }

                disabled={!poId}

                fetchOptions={(search) =>
                  poLineLookupService.search(poId, search)
                }

                getOptionLabel={(o) =>
                  `${o.material_name} (Pending: ${o.pending_qty})`
                }

                getOptionValue={(o) => o.line_id}

                onChange={(v) =>
                setForm({
                  ...form,

                  po_line_id: v.line_id,
                  po_line_label: `${v.material_name}`,

                  material_id: v.material_id,
                  material_label: `${v.material_name}`,

                  // CRITICAL FIX – copy material type from PO line
                  material_type: v.material_type,

                  uom: v.uom,
                  unit_price: v.rate,

                  received_qty: "",
                  pending_qty: v.pending_qty,
                })
              }

              />
            </div>

            {/* MATERIAL TYPE */}
            <div className="col-6">
              <label className="form-label">Material Type</label>
              <input
                type="text"
                className="form-control"
                value={
                  form.material_type === "RAW_MATERIAL"
                    ? "Raw Material"
                    : "Bought Out"
                }
                readOnly
              />
            </div>

            {/* MATERIAL DROPDOWN */}
            <div className="col-6">
                <input
                  type="text"
                  className="form-control"
                  value={form.material_label}
                  readOnly
                />
             </div>

            {/* UOM AUTO FIELD */}
            <div className="col-6">
              <label className="form-label">UOM</label>
              <input
                type="text"
                className="form-control"
                value={form.uom}
                readOnly
              />
            </div>

            <div className="col-6">
              <label className="form-label">Pending Qty</label>
              <input
                type="number"
                className="form-control"
                value={form.pending_qty}
                readOnly
              />
            </div>
            {/* RECEIVED QTY */}
            <div className="col-6">
              <label className="form-label">Received Qty</label>
              <input
                type="number"
                className="form-control"
                value={form.received_qty}
                onChange={(e) => {
                  const qty = parseFloat(e.target.value || 0);

                  

                  setForm({
                    ...form,
                    received_qty: qty,
                  });
                }}
              />
            </div>

            

            {/* UNIT PRICE */}
            <div className="col-6">
              <label className="form-label">Unit Price</label>
              <input
                type="number"
                className="form-control"
                name="unit_price"
                value={form.unit_price}
                onChange={handleChange}
              />
            </div>

            <div className="col-6">
              <label className="form-label">
                Batch No <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                name="batch_no"
                value={form.batch_no}
                onChange={handleChange}
              />
            </div>

            <div className="col-6">
              <label className="form-label">
                Expiry Date <span className="text-danger">*</span>
              </label>
              <input
                type="date"
                className="form-control"
                name="expiry_date"
                value={form.expiry_date}
                onChange={handleChange}
              />
            </div>

          </div>
        </div>

        <div className="erp-drawer-footer">
          <button className="btn btn-secondary" onClick={onClose}>
            Cancel
          </button>

          <button
            className="btn btn-primary"
            onClick={handleSave}
            disabled={saving}
          >
            {saving ? "Saving..." : "Save Line"}
          </button>
        </div>

      </div>
    </div>
  );
}
